//路由引入结束
import Vue from "vue";
import VueRouter from "vue-router";

import Common from "./common.js";
import ConfigRouters from "./modules";
// import store from '@/store';
Vue.use(VueRouter);
const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_BASE_PATH,
  routes: ConfigRouters.concat(Common),
  scrollBehavior(to, from, savedPosition) {
    if (
      [
        "/mistakesCenter/examPreview",
        "/mistakesCenter/mistakesPreview"
      ].includes(from.path) &&
      savedPosition
    ) {
      // if (from.path == '/mistakesCenter/examPreview' && savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 }; //期望滚动到哪个的位置
    }
  }
});

// 全局判断微信授权拦截
/**
 * @methods
 * @isAuthorize 判断是否需要授权 微信浏览器 且未登录 沒有微信返回的code码
 * 用户同意授权，获取code(可以由前端来做)
 * 通过code换取网页授权access_token
 * 刷新access_token(如果需要)
 * 拉取用户信息
 */
let isAuthorize = () => {
  // 判斷是否是微信浏览器
  let ua = navigator.userAgent.toLocaleLowerCase();
  return ua.indexOf("micromessenger") != -1;
};

router.beforeEach((to, from, next) => {
  document.title = to.meta.title; //动态渲染title
  // const isLogin = store.state.token
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (isLogin) {
      //axios.defaults.headers.token = isLogin
      // next();
    } else {
      // next({
      // 		path: '/login',
      // 		query: {
      // 				redirect: to.fullPath
      // 		}
      // })
      next();
    }
  } else {
    next();
  }
});

//先把VueRouter原型对象的push保存一份
const originPush = VueRouter.prototype.push
//重写push方法 
VueRouter.prototype.push = function (location,resolve,reject) {
    //调用保存的push方法
    //但是保存的push方法是挂载在window的方法 所以要通过call修改this的指向
  if(resolve&&reject){
    originPush.call(this,location,resolve,reject);
  }else{
    originPush.call(this,location,()=>{},()=>{});
  }
}
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js